import { CustomPosition, TooltipComponent } from 'Pages/landings/newLandings/common/components'
import { TooltipTitle } from 'Pages/landings/newLandings/products/rboPage/Form/TooltipTitle'
import { IconQuestion } from 'Pages/landings/newLandings/products/rboPage/Form/IconQuestion'
import React, { useMemo } from 'react'
import { useWindowSize } from 'Pages/landings/newLandings/common/hooks'

const coordY = -22

const calculateCoordX = (width: number) => {
	if (width < 768) return -133
	return 0
}

export const IconTooltip = () => {
	const { width } = useWindowSize()
	const coordX = calculateCoordX(width)
	const setCustomPosition = useMemo(
		(): CustomPosition => ({
			name: 'setCustomPosition',
			fn: ({ x, y }) => ({
				x: x + coordX,
				y: y + coordY,
			}),
		}),
		[coordY, coordY]
	)
	return (
		<TooltipComponent
			tooltipId="icon_question"
			title={<TooltipTitle />}
			middlewares={[setCustomPosition]}
		>
			<IconQuestion />
		</TooltipComponent>
	)
}
